"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contractorTypes = exports.contractorReducer = exports.contractorAction = void 0;
const contractor_component_1 = __importDefault(require("./sub-components/contractor.component"));
const contractor_action_1 = __importDefault(require("./contractor.action"));
exports.contractorAction = contractor_action_1.default;
const contractor_reducer_1 = __importDefault(require("./contractor.reducer"));
exports.contractorReducer = contractor_reducer_1.default;
const contractor_types_1 = require("./contractor.types");
Object.defineProperty(exports, "contractorTypes", { enumerable: true, get: function () { return contractor_types_1.contractorTypes; } });
exports.default = contractor_component_1.default;
